import { UnorderedList,ListItem, Text, Box, Flex, Button, Textarea} from "@chakra-ui/react";
import React from 'react';
import {map as m,addIndex} from "ramda";
import {Weighting} from "./multiselect";
import { MultipleInput } from "./MultipleInput";
import { Scale } from "./scale";
import { NrOfVotes } from "./nr_of_votes";
import { VoteCount } from "./vote_count";
import { SingleChoice } from "./single_choice";
import { ChosenAlternative } from "./chosen_alternative";
import { TopCriterion } from "./top_criterion";
import { weighted, r } from "./helpers";
import {useUpdateDecisionMutation, useUpsertDataMutation} from "../app/api";
import { useSelector } from "react-redux";
import {path} from "ramda";	
import { Field, Form, Formik } from "formik";


const translate_results = (x,{
    no,r_no,so_so,
    r_yes,yes,
    negative,r_negative,
    r_positive,positive
  },type) => type === "posNeg" ? 
    ( 
      x < -0.75 ? `${negative} (${x})`  : 
      x < -0.25 ? `${r_negative} (${x})`: 
      x < 0.25  ? `${so_so} (${x})`     :
      x < 0.75  ? `${r_positive} (${x})`:
                  `${positive} (${x})`
    ) : (
      x < -0.75 ? `${no} (${x})`        : 
      x < -0.25 ? `${r_no} (${x})`      : 
      x < 0.25  ? `${so_so} (${x})`     :
      x < 0.75  ? `${r_yes} (${x})`     :
                  `${yes} (${x})`
    );
  
                    
const WeightedAverage = (props) => {
  const texts = useSelector(path(["ui","ui_texts"]));
  const [moveForward] = useUpdateDecisionMutation();
  return <Box>
      <Text><b>{translate_results(weighted(props?.items),texts)}</b></Text>
      {(props.is_last || (props.show_until >props.order_nr)) ? null : <Flex mt={2} gap={2}>
          <Button size="md" colorScheme="blue" 
            onClick={() => {moveForward({
              id: props.decision_id,
              done:props.order_nr,
              show_until:props.next_to_show
            })}}>
            {texts.next}
          </Button>  
        </Flex>}
    </Box>
}

const Average = (props) => {
  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui","ui_texts"]));
  const avg = r(3,props.items2?.reduce((acc,x) => acc+x.value_number,0)/props.items2?.length);
  const hide_next_btn = (props.done_item === null && props.data_input == null) ? 
  (props.show_until > props.order_nr) : !props.next_btn_visible;
  return <Box>
      {props.activity.type === "average_simple" ? 
        <Text>
          <b>{translate_results(avg,texts,props.activity.scale)}</b>
        </Text> :
        <Text>{texts.answered} {props.items2?.length}, {texts.average} <b>
          {translate_results(avg,texts,props.activity.scale)}</b>
        </Text> }
      {hide_next_btn ? null : <Flex mt={2} gap={2}>
          <Button size="md" colorScheme="blue" 
            onClick={() => {moveForward({
              id: props.decision_id,
              done:props.order_nr,
              show_until:props.next_to_show
            })}}>
            {texts.next}
          </Button>  
        </Flex>}
    </Box>
}

const Decide = (props) => {
  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui","ui_texts"]));
  const responses = props.data.filter(x => 
    (props.activity.is_private ? x.participant_id === props.participant_id : true) && 
    x.activity_id === props.activity.id);
  const [upsertData] = useUpsertDataMutation();
  const hide_next_btn = (props.done_item === null || props.data_input === null) ? 
    (props.show_until > props.order_nr) : !props.next_btn_visible;

  const handleSubmit = x => () => {
    upsertData([{
      value_number: x,
      participant_id:props.participant_id,
      decision_id:props.decision_id,
      activity_id:props.activity.id}]);
  };

  return <>
    <Box>
      {responses.length ? `${texts.decision}: ${(texts[responses[0].value_number ? "yes_button" : "no_button"])}` : 
      <Flex gap="2" mt="2">
        <Button size="md" colorScheme="teal" onClick={handleSubmit(1)}>{texts.yes_button}</Button> 
        <Button size="md" colorScheme="teal" onClick={handleSubmit(0)}>{texts.no_button}</Button> 
      </Flex> }
    </Box>
    {hide_next_btn ? null : <Flex mt={2} gap={2}>
      <Button size="md" colorScheme="blue" onClick={() => {
        moveForward({
          id: props.decision_id,
          done:props.order_nr,
          done_item:props.done_item,
          show_until:props.next_to_show
        })}}>
        {texts.next}
      </Button>  
    </Flex>}
  </>
}
const SmallInput = (props) => {}

const LargeInput = (props) => {
  const [moveForward] = useUpdateDecisionMutation();
  const [upsertData] = useUpsertDataMutation();
  const texts = useSelector(path(["ui","ui_texts"]));
  const hide_next_btn = (props.done_item === null || props.data_input === null) ? 
    (props.show_until > props.order_nr) : !props.next_btn_visible;

  const handleSubmit = x => {
    upsertData([{
      id:x.inputs[0].id,
      value_text: x.inputs[0].value_text,
      participant_id:props.participant_id,
      decision_id:props.decision_id,
      activity_id:props.activity.id}]);
  };
  return <Box>
    <Text fontSize="lg">{props.isMemo ? props.items[0].value_text : props.activity.text}</Text>
    <Formik
      enableReinitialize={true}
      initialValues={{ inputs: props.filtered }}
      onSubmit={handleSubmit}
    >{({ values, dirty }) => 
      <Form>
        <Field name="inputs[0].value_text" as={Textarea} autoComplete="off" />
        {hide_next_btn ? null : <Flex mt={2} gap={2}>
          <Button size="md" colorScheme="teal" type="submit" isDisabled={!dirty}>
            {texts.save}
          </Button>
          <Button size="md" colorScheme="blue" onClick={() => {
            moveForward({
              id: props.decision_id,
              done:props.order_nr,
              done_item:props.done_item,
              show_until:props.next_to_show
            })}}>
            {texts.next}
          </Button>  
        </Flex>}
      </Form>}
    </Formik>
  </Box>
}

const Result = (props) => {
  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui","ui_texts"]));
  const hide_next_btn = (props.done_item === null || props.data_input === null) ? 
    (props.show_until > props.order_nr) : !props.next_btn_visible;

  return <Box>
    <UnorderedList>{
      addIndex(m)((x,n) => <ListItem key={x.id}>{x.value_text}</ListItem>,props.items)}
    </UnorderedList>
    {hide_next_btn ? null : <Flex mt={2} gap={2}>
      <Button size="md" colorScheme="blue" onClick={() => {
        moveForward({
          id: props.decision_id,
          done:props.order_nr,
          done_item:props.done_item,
          show_until:props.next_to_show
        })}}>
        {texts.next}
      </Button>  
    </Flex>}
  </Box>
}

export const activity_types = (el,props) => {
  return {
  multiple_input: <MultipleInput {...props}/>,
  large_input: <LargeInput {...props}/>,
  memo: <LargeInput isMemo={true} {...props}/>,
  small_input: <SmallInput {...props}/>,
  weighting: <Weighting {...props}/>,
  voting: <Scale {...props}/>,
  weighted_average: <WeightedAverage {...props}/>,
  result: <Result {...props}/>,
  average: <Average {...props}/>,
  average_simple: <Average {...props}/>,
  binary: <Decide {...props}/>,
  nr_of_votes: <NrOfVotes {...props}/>,
  vote_count: <VoteCount {...props}/>,
  single_choice: <SingleChoice {...props}/>,
  chosen_alternative: <ChosenAlternative {...props}/>,
  top_criterion: <TopCriterion {...props}/>,
}[el]}
